import React, { useState } from 'react';
import { Gavel } from 'lucide-react';
import type { BulkUpdates } from '../../../types/bulk';
import { BulkApplyButton, BulkFieldRow } from '../BulkFieldRow';

interface BulkPriceFieldProps {
  onUpdate: (updates: BulkUpdates) => void;
}

export function BulkPriceField({ onUpdate }: BulkPriceFieldProps) {
  const [startPrice, setStartPrice] = useState('');
  const [buyItNowPrice, setBuyItNowPrice] = useState('');

  const handleApply = () => {
    const updates: BulkUpdates = {};
    if (startPrice) {
      updates.startPrice = Number(startPrice);
    }
    if (buyItNowPrice) {
      updates.buyItNowPrice = Number(buyItNowPrice);
    }
    if (Object.keys(updates).length > 0) {
      onUpdate(updates);
      setStartPrice('');
      setBuyItNowPrice('');
    }
  };

  return (
    <BulkFieldRow
      icon={<Gavel className="w-5 h-5 text-gray-500 shrink-0" />}
      label="価格を変更"
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center md:flex-nowrap">
        <div className="flex min-w-0 w-full items-center gap-1.5 sm:w-auto sm:flex-none sm:w-32">
          <input
            type="number"
            value={startPrice}
            onChange={(e) => setStartPrice(e.target.value)}
            placeholder="開始価格"
            className="h-[30px] min-w-0 flex-1 rounded-md border border-gray-300 bg-gray-50 px-2 text-sm sm:w-32 sm:flex-none"
          />
          <span className="text-sm text-gray-500 shrink-0">円</span>
        </div>
        <div className="flex min-w-0 w-full items-center gap-1.5 sm:w-auto sm:flex-none sm:w-32">
          <input
            type="number"
            value={buyItNowPrice}
            onChange={(e) => setBuyItNowPrice(e.target.value)}
            placeholder="即決価格"
            className="h-[30px] min-w-0 flex-1 rounded-md border border-gray-300 bg-gray-50 px-2 text-sm sm:w-32 sm:flex-none"
          />
          <span className="text-sm text-gray-500 shrink-0">円</span>
        </div>
      </div>
      <BulkApplyButton
        disabled={!startPrice && !buyItNowPrice}
        onClick={handleApply}
      />
    </BulkFieldRow>
  );
}
